export default __webpack_public_path__ + "static/media/mr.74a71f66.svg";